import API from './base';

class ExamCenterReviewAPI extends API {
  create(payload) {
    return this.post('/api/web/v1/exam_center_reviews', payload);
  }
}

export const ExamCenterReviewAPIInstance = new ExamCenterReviewAPI();
